// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__rQ7Zw","fileBtn":"File_fileBtn__1l5WK","closeBtn":"File_closeBtn__3RqWi","fileSelected":"File_fileSelected__JIh0l","disabled":"File_disabled__3lJiv"};